import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=03a9e42e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a9e42e')) {
      api.createRecord('03a9e42e', component.options)
    } else {
      api.reload('03a9e42e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=03a9e42e&", function () {
      api.rerender('03a9e42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/comp/IncreaseNumber.vue"
export default component.exports